import wrapURL from '@/components/bloodDraw/BloodDrawData/interceptors.js';
export const payoutBaseURL = wrapURL(
    process.env.VUE_APP_ENV=='production' 
    ? 'https://api.vibrant-wellness.com/v1/payout'
    : 'https://api.vibrant-wellness.com/v1/payout/staging'
);
